
import React, { useEffect, useState, useCallback } from 'react'
import {
    Row,
    Col,
    Button,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Spinner as ButtomSpinner
} from 'reactstrap'
import { isUndefined } from '@common/utils'
import { Search, Trash, ChevronDown, ChevronLeft, ChevronRight } from 'react-feather'
import Spinner from '@components/@vuexy/spinner/Fallback-spinner'
import Header from '@components/DataList/Header'
import SweetAlert from 'react-bootstrap-sweetalert'
import Flatpickr from 'react-flatpickr'
import DataTable from 'react-data-table-component'
import ReactPaginate from 'react-paginate'
import classnames from "classnames"

import * as IotData from '@apis/iotData'
import moment from 'moment-timezone'

import '@assets/scss/plugins/forms/flatpickr/flatpickr.scss'
import '@assets/scss/plugins/extensions/react-paginate.scss'
import '@assets/scss/components/data-list.scss'
import '@assets/scss/components/alertTab.scss'
import 'flatpickr/dist/themes/light.css'

const columns = [
    {
        name: 'Alert Massage',
        selector: 'alertName',
        sortable: true,
        minWidth: '500px',
        maxWidth: '600px',
    },
    {
        name: 'Alert Type',
        selector: 'alertType',
        sortable: true,
        minWidth: '100px',
        maxWidth: '150px',
    },
    {
        name: 'Start Date Time',
        selector: 'startDateTime',
        sortable: true,
        minWidth: '150px',
        maxWidth: '200px',
        cell: (row) => {
            return moment(row.startDateTime).format('YYYY-MM-DD HH:mm:ss')
        }
    },
    {
        name: 'End Date Time',
        selector: 'endDateTime',
        sortable: true,
        minWidth: '150px',
        maxWidth: '200px',
        cell: (row) => {
            return moment(row.endDateTime).format('YYYY-MM-DD HH:mm:ss')
        }
    },
    {
        name: 'Amount (s)',
        selector: 'amount',
        sortable: true,
        minWidth: '100px',
        maxWidth: '150px',
    }
]

const alertTypeConst = [
    { id: 1, value: 'Device', name: 'Device' },
    { id: 2, value: 'ML', name: 'Machine Learning' }
]

const firstDayInMonth = () => {
    const today = new Date()
    return new Date(today.getFullYear(), today.getMonth(), 1)
}

const defaultCriteria = {
    keyword: '',
    startDate: firstDayInMonth(),
    startTime: firstDayInMonth().toTimeString(),
    endDate: new Date(),
    endTime: new Date().toTimeString(),
    alertType: null
}

const noCriteria = {
    keyword: '',
    startDate: null,
    startTime: null,
    endDate: null,
    endTime: null,
    alertType: null
}

const defaultPaging = {
    pageNumber: 1,
    pageSize: 4
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

    if (month.length < 2) {
        month = '0' + month
    }
    if (day.length < 2) {
        day = '0' + day
    }

    return [year, month, day].join('-')
}

function formatTime(time) {
    return time.slice(0, 8)
}

const AlertTab = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isAlertLoading, setIsAlertLoading] = useState(false)

    const [criteria, setCriteria] = useState(defaultCriteria)

    const [isAlreadySearch, setIsAlreadySearch] = useState(false)
    const [alertData, setAlertData] = useState([])
    const [totalAlert, setTotalAlert] = useState(0)
    const [paging, setPaging] = useState(defaultPaging)

    // SweetAlert
    const showAlert = (type, header, message, callback, showCancel = false) => {
        setAlertModel({
            isShow: true,
            header: header,
            message: message,
            type: type,
            callback: callback,
            showCancel: showCancel,
        })
    }

    const closeAlert = () => {
        setAlertModel({ isShow: false, callback: closeAlert })
    }

    const [errMsg, setErrMsg] = useState('')
    const [alertModel, setAlertModel] = useState({ isShow: false, callback: closeAlert })

    const renderErr = () => {
        showAlert('error', 'Error', `Error is ${errMsg}`, () => closeAlert())
        setErrMsg('')
    }

    useEffect(() => {
        setIsLoading(true)
        setCriteria(defaultCriteria)
        setPaging(defaultPaging)
        setIsLoading(false)
    }, [props])

    const onCriteriaChange = useCallback((key) => (value) => {
        const newCriteria = { ...criteria, [key]: value }
        const newPaging = { ...paging, pageNumber: 1 }
        setCriteria(newCriteria)
        setPaging(newPaging)
        onSearchAlert(newCriteria, newPaging)
    }, [criteria, paging])

    const onPageChange = useCallback((newPage) => {
        const newPaging = { ...paging, pageNumber: newPage }
        setPaging(newPaging)
        onSearchAlert(criteria, newPaging)
    }, [criteria, paging])

    const onPageSizeChange = useCallback((pageSize) => {
        const newPaging = { ...paging, pageNumber: 1, pageSize }
        setPaging(newPaging)
        onSearchAlert(criteria, newPaging)
    }, [criteria, paging])

    const onSearchAlert = async (searchCriteria, searchPaging) => {
        try {
            setIsAlertLoading(true)
            const { alertData, totalData } = await IotData.getAlertDataByCriteria({
                ...searchCriteria,
                ...searchPaging,
                ukey: props.iotData.ukey,
                startDate: formatDate(searchCriteria.startDate),
                startTime: formatTime(searchCriteria.startTime),
                endDate: formatDate(searchCriteria.endDate),
                endTime: formatTime(searchCriteria.endTime)
            })
            setIsAlreadySearch(true)
            setAlertData(alertData)
            setTotalAlert(totalData)
            setIsAlertLoading(false)
        } catch (error) {
            setErrMsg(error)
        }
    }


    const renderPaging = () => {
        return (
            <ReactPaginate
                previousLabel={<ChevronLeft size={15} />}
                nextLabel={<ChevronRight size={15} />}
                breakLabel='...'
                breakClassName='break-me'
                pageCount={Math.ceil(totalAlert / paging.pageSize)}
                containerClassName='vx-pagination separated-pagination pagination-end mb-0 mt-2'
                activeClassName='active'
                initialPage={paging.pageNumber - 1}
                disableInitialCallback={true}
                onPageChange={page => {
                    onPageChange(page.selected + 1)
                }}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
            />
        )
    }

    const renderAlertTab = () => {
        return (
            <>
                <Col lg='12' xl='9'>
                    <div className='alert-header'>Alert Tab</div>
                    <ul className='list-inline alert-date-time pt-1'>
                        <li className='list-inline-item mb-1'>
                            <span className='label-date'>
                                Start Date
                            </span>
                            <Flatpickr
                                className='form-control'
                                placeholder='Select Date'
                                value={criteria.startDate}
                                onChange={date => {
                                    if (!isUndefined(date[0])) {
                                        setCriteria({
                                            ...criteria,
                                            startDate: date[0],
                                            startTime: defaultCriteria.startTime
                                        })
                                    } else {
                                        setCriteria({
                                            ...criteria,
                                            startDate: null,
                                            startTime: null
                                        })
                                    }
                                }}
                                options={{
                                    maxDate: criteria.endDate || new Date()
                                }}
                            />
                        </li>
                        <li className='list-inline-item mb-1'>
                            <span className='label-date'>
                                Start Time
                            </span>
                            <Flatpickr
                                className='form-control select-time'
                                placeholder='Time'
                                value={criteria.startTime}
                                disabled={
                                    isUndefined(criteria.startDate)
                                }
                                onChange={date => {
                                    setCriteria({
                                        ...criteria,
                                        startTime: date[0].toTimeString()
                                    })
                                }}
                                options={{
                                    time_24hr: true,
                                    enableTime: true,
                                    noCalendar: true,
                                    dateFormat: 'H:i',
                                }}
                            />
                        </li>
                        <li className='list-inline-item mb-1'> - </li>
                        <li className='list-inline-item mb-1'>
                            <span className='label-date'> End Date </span>
                            <Flatpickr
                                className='form-control'
                                placeholder='Select Date'
                                value={criteria.endDate}
                                onChange={date => {
                                    if (!isUndefined(date[0])) {
                                        setCriteria({
                                            ...criteria,
                                            endDate: date[0],
                                            endTime: defaultCriteria.startTime
                                        })
                                    } else {
                                        setCriteria({
                                            ...criteria,
                                            endDate: null,
                                            endTime: null
                                        })
                                    }
                                }}
                                options={{
                                    minDate: criteria.startDate || undefined,
                                    maxDate: new Date()
                                }}
                            />
                        </li>
                        <li className='list-inline-item mb-1 mr-2'>
                            <span className='label-date'>
                                End Time
                            </span>
                            <Flatpickr
                                className='form-control select-time'
                                value={criteria.endTime}
                                placeholder='Time'
                                disabled={
                                    isUndefined(criteria.endDate)
                                }
                                onChange={date => {
                                    setCriteria({
                                        ...criteria,
                                        endTime: date[0].toTimeString()
                                    })
                                }}
                                options={{
                                    time_24hr: true,
                                    enableTime: true,
                                    noCalendar: true,
                                    dateFormat: 'H:i',
                                }}
                            />
                        </li>
                        <li className='list-inline-item'>
                            {/* <div className='label-alert'>
                                Alert Type
                            </div> */}
                            <div className='dropdown d-inline-block'>
                                <UncontrolledButtonDropdown>
                                    <Button outline color='primary'>
                                        {!isUndefined(criteria.alertType) ?
                                            alertTypeConst.filter((item) => item.value === criteria.alertType)[0].name
                                            : `All Type`}
                                    </Button>
                                    <DropdownToggle
                                        color='primary'
                                        className='dropdown-toggle-split p-1'
                                        caret
                                    >
                                        <ChevronDown size={15} />
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem
                                            onClick={
                                                () => setCriteria({
                                                    ...criteria,
                                                    alertType: null
                                                })
                                            }
                                        >
                                            All Type
                                        </DropdownItem>
                                        {
                                            alertTypeConst.map((item) => {
                                                return (
                                                    <DropdownItem
                                                        key={item.id}
                                                        onClick={
                                                            () => setCriteria({
                                                                ...criteria,
                                                                alertType: item.value
                                                            })
                                                        }
                                                    >
                                                        {item.name}
                                                    </DropdownItem>
                                                )
                                            })
                                        }
                                    </DropdownMenu>
                                </UncontrolledButtonDropdown>
                            </div>
                        </li>
                    </ul>
                </Col >
                <Col lg={12} xl={3} className="action-buttom">
                    <Button
                        color='primary'
                        className='mr-1 mb-2'
                        disabled={
                            isUndefined(criteria.startDate) || isUndefined(criteria.endDate)
                        }
                        onClick={() => {
                            setIsAlreadySearch(false)
                            setPaging(defaultPaging)
                            onSearchAlert(criteria, defaultPaging)
                        }}
                    >
                        {isAlertLoading && !isAlreadySearch ? (
                            <ButtomSpinner
                                className={classnames({
                                    "position-relative": true,
                                    visible: isAlertLoading,
                                    invisible: !isAlertLoading
                                })}
                                size="sm"
                            />
                        ) : (
                            <span>
                                <Search className='mr-1' size={16} />
                                <b>Search</b>
                            </span>
                        )}
                    </Button>
                    <Button
                        outline
                        color='light'
                        className="mb-2"
                        onClick={() => {
                            setCriteria(noCriteria)
                        }}
                    >
                        <span>
                            <Trash className='mr-1' size={16} />
                            <b>Reset</b>
                        </span>
                    </Button>
                </Col>
                <div />
                {isAlreadySearch &&
                    <Col xs={12} className='data-list list-view'>
                        <header className='pl-0'>
                            <Header
                                className='data-list-header'
                                onCriteriaChange={onCriteriaChange}
                                criteria={criteria}
                                onPageSizeChange={onPageSizeChange}
                                pageSize={paging.pageSize}
                                pageNumber={paging.pageNumber}
                                totalRecord={totalAlert}
                                hideAddButton
                            />
                        </header>
                        <DataTable
                            columns={columns}
                            data={alertData}
                            progressPending={isAlertLoading}
                            progressComponent={
                                <Spinner className='spinner' color='primary' size='lg' />
                            }
                            pagination
                            paginationComponent={renderPaging}
                            persistTableHead
                            noHeader
                            noSubHeader
                            responsive
                            pointerOnHover
                            sortIcon={<ChevronDown />}
                        />
                    </Col>
                }
            </>
        )
    }

    return (
        <Row className='m-1'>
            {isLoading ? <Spinner /> : renderAlertTab()}
            {errMsg !== '' ? renderErr() : null}
            <div className='equipment-model-detail'>
                <SweetAlert
                    type={alertModel.type}
                    title={alertModel.header || ''}
                    show={alertModel.isShow}
                    onConfirm={alertModel.callback}
                    onCancel={closeAlert}
                    showCancel={alertModel.showCancel}
                    showConfirm={alertModel.type === 'success' ? false : true}
                    reverseButtons
                    cancelBtnBsStyle='danger'
                    timeout={alertModel.type === 'success' ? 2000 : null}
                >
                    <p className='sweet-alert-text'>{alertModel.message}</p>
                </SweetAlert>
            </div>
        </Row>
    )
}

export default AlertTab
